import {getSessionFromSlotOrSession} from "./getSessionFromSlotOrSession";
import {FieldCompInputType} from "@shared/components/FieldsBuilder/fieldCompCustomProps/FieldCompInputType";
import {NOEEndpointExtended} from "@shared/inputs/NOEObjectSelectInput";
import {getAllCustomFieldValuesForEndpoint} from "./getAllCustomFieldValuesForEndpoint";

/**
 * @typedef {object} CustomFieldFilter
 * @property {string} key
 * @property {FieldCompInputType} type
 * @property {NOEEndpointExtended} endpoint
 * @property {Array<string>} filterValues
 */

// Tells if a session is selected of not by a custom field
/**
 * @param {CustomFieldFilter} filter
 * @param {*} session
 * @param {*} [registrations]
 * @returns {boolean}
 */
const sessionIsSelectedByCustomField = ({key, endpoint, filterValues}, session, registrations) => {
  const allCustomFieldValuesForObject = getAllCustomFieldValuesForEndpoint(
    key,
    endpoint,
    session,
    registrations
  );

  // We check if any of the custom fields values gathered is matching the filterValues filter
  return !!filterValues.find((value) => allCustomFieldValuesForObject?.includes(value));
};

/**
 * Filter sessions or slots by custom fields
 * @param {Array<object>} slotsOrSessions - Array of slots or sessions to filter
 * @param {Array<CustomFieldFilter>} customFieldsFilters - Array of custom field filters
 * @param {Array<object>} [registrations] - Optional registrations array
 * @returns {Array<object>} Filtered array of slots or sessions
 */
export const filterSessionsByCustomFields = (
  slotsOrSessions,
  customFieldsFilters,
  registrations
) => {
  // Only take the fields which are filtering something. If a filter doesn't have any value, it doesn't filter anything.
  const allFilteredCustomFields = customFieldsFilters.filter(
    ({filterValues}) => filterValues?.length > 0
  );

  // For each slot/session, filter them...
  return slotsOrSessions?.filter((item) => {
    // Get the session
    const session = getSessionFromSlotOrSession(item);
    // And check if it matches all the custom fields filters
    return allFilteredCustomFields.every((customField) =>
      sessionIsSelectedByCustomField(customField, session, registrations)
    );
  });
};
